import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ue9948gsud: FaireBrandEntity = {
  token: "b_ue9948gsud",
  type: "brand",
  name: "Rigaud",
  avatarUrl:
    "https://cdn.faire.com/fastly/279e0b55b9e6712a520e1d706b68f5b86285c77addb85a1b51931e520c0a5e4c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f17822ebb42bf5eb9c9e776db6e006b755177f9f74701909b1c4e2cf88973fa9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/279e0b55b9e6712a520e1d706b68f5b86285c77addb85a1b51931e520c0a5e4c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f17822ebb42bf5eb9c9e776db6e006b755177f9f74701909b1c4e2cf88973fa9.jpeg",
  location: "ROCKLEIGH, NJ, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "The Rigaud story starts in 1852... \nJean Baptiste Rigaud became fascinated by the world of scent and began developing the distinctive perfumes for which the Rigaud brand would later become famous. Over the next half century Jean-Baptiste proved himself to be both a parfumier of genius and an innovator par excellence. \n\nFollowing the Second World War, Parfumerie Rigaud passed into the hands of the third generation: Mario Rigaud and his wife Viviane. Together with her husband she conceived an entirely new product: The world’s first scented and marketed candle. The result in 1959 was their masterpiece: Cyprès. Henri created a totally new fragrance inspired by the pine forests of the Mediterranean, and a patented soft wax was specifically developed to release and diffuse that fragrance with both intensity and longevity.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:33.890Z",
    importedBy: "entity-db-cli",
  },
};
